var Stock = /** @class */ (function () {
    function Stock(props) {
        Object.assign(this, props);
    }
    return Stock;
}());
export { Stock };



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stock/Model.ts
// module id = 696
// module chunks = 0